import { CompanyRole } from "../../../auth/AuthProvider";
import { FourEyesMode, TCompanyRole } from "../network";

export type TCompanyWithRole = {
  id: string;
  name: string;
  isActive: boolean;
  emailNotificationEnabled: boolean;
  purpose: string;
  picture: string;
  complianceEmail: string;
  role: CompanyRole;
  fourEyesMode: FourEyesMode;
};

export type TCompany = Omit<TCompanyWithRole, "role">;

export type TOfficer = {
  id: string;
  name: string;
  email: string;
  phone: string;
  companyRole: TCompanyRole[];
};

export type IS3UploadRequest = {
  key: string;
  url: string;
};
export interface IApplicationKeys {
  apiOrigin: string;
  widgetUrl: string;
  publicKey: string;
  appPublicKey: string;
  appToken: string;
  webhookSecretKey: string;
}
export interface IGeneratedKeys extends IApplicationKeys {
  privateKey: string;
}
export interface IViewKeys extends IApplicationKeys {
  webhookUrl: string;
}
export interface ICreateCoutryRegex {
  country: string;
  type: string;
  regexp: string;
  example: string;
  mask?: string;
}
export interface ICountryRegex extends ICreateCoutryRegex {
  id: string;
  createdAt: string;
  updatedAt: string;
}

export const AUTH_COMPANY_ID = "company_id";
export const AUTH_COMPANY_NAME = "company_name";
export const AUTH_COMPANY_PURPOSE = "company_purpose";
export const AUTH_COMPLIANCE_EMAIL = "compliance_email";

export type ICompanyActionModeType = "create" | "edit" | "delete" | "";
export enum CompaniesTabs {
  LIST = "?list",
  OFFICERS = "?officers",
  APPS = "?apps",
}

export const CompaniesTabsView = [
  CompaniesTabs.LIST,
  CompaniesTabs.OFFICERS,
  CompaniesTabs.APPS,
];
